
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkNewsReadConfirmationReminderChannelEnum } from '../models/work-news-read-confirmation-reminder-channel-enum';

export function getCreateNewsDtoFormGroup() {
return new FormGroup({
    title: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    text: new FormControl<string | undefined>('', [Validators.required]),
    accessKey: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    requestReadConfirmation: new FormControl<boolean | undefined>(undefined),
    readConfirmationDueDate: new FormControl<string | undefined>(undefined),
    readConfirmationReminderDaysBefore: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(365)]),
    readConfirmationReminderChannel: new FormControl<WorkNewsReadConfirmationReminderChannelEnum | undefined>(undefined),
    allowComments: new FormControl<boolean | undefined>(undefined),
    showFrom: new FormControl<string | undefined>(new Date().toISOString()),
    showUntil: new FormControl<string | undefined>("2199-12-31"),
    headerImageId: new FormControl<number | undefined>(undefined),
    newsImageId: new FormControl<number | undefined>(undefined),
    createdBy: new FormControl<number | undefined>(undefined),
})
;
}
      